import { inject, Pipe, PipeTransform } from '@angular/core';
import { DurationFormat } from 'src/app/helpers/units';
import { UnitFormatService } from 'src/app/services/translation/unit-format.service';

/** Abbreviated duration in the active language — see `formatDurationSeconds`.
 *  Impure so the unit suffixes follow a language switch. */
@Pipe({
  name: 'duration',
  pure: false,
})
export class DurationPipe implements PipeTransform {
  private readonly units = inject(UnitFormatService);

  transform(seconds: number, format: DurationFormat = 'short'): string {
    return this.units.duration(seconds, format);
  }
}
